export const MAP_STORE_UPDATE_DELAY = 50
export const MIN_INTERVAL_TO_DISTINGUISH_SGLE_FROM_DBL_TAP = 200
export const DELAY_TO_TRIGGER_CONTEXTMENU_ON_MOBILE = 600

export const MAP_ZOOM_STEP = 1
export const MAP_ZOOM_MIN = 3
export const MAP_RASTER_ZOOM_MAX = 18
export const MAP_VECTOR_ZOOM_MAX = 18.99
